import {
  DeleteButton,
  DisabledButton,
  PrintButton,
  ResetButton,
  SplitButton,
  SubmitButton
} from "@websential/cosmic";
import { FC, useState } from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IAppState } from "../../../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import PrintIcon from "@mui/icons-material/Print";
import { RL3SlipService } from "../../../../services/RL3SlipService";
import { Toolbar } from "@mui/material";
import { selectedRL3SlipType } from "../RL3SlipSetup";
import { selectedRL3SummaryType } from "../../../../components/RL3Slip/RL3SlipSummarySetup";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

export interface IRL3SlipSetupToolbar {
  onResetClicked: () => void;
  onDeleteClicked: () => void;
  onPrintClicked: () => void;
  isSubmitting: boolean;
  formMethods: any;
}

const RL3_SUMMARY_DATA_QUERY_KEY = "get-rl3-summary-data";
const useGetRL3SummaryData = (
  clientid: string,
  slipType: string | number,
  taxYear: number
) =>
  useQuery({
    queryKey: [RL3_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
    queryFn: (data) => {
      return RL3SlipService.getRL3Summary(clientid, slipType, taxYear);
    },
    refetchOnWindowFocus: false
  });

export const RL3SlipSetupToolbar: FC<IRL3SlipSetupToolbar> = ({
  onResetClicked,
  onDeleteClicked,
  onPrintClicked,
  isSubmitting = false,
  formMethods,
}) => {
  const id = useSelector((state: IAppState) => state.client.id);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  // const [selectedType, setSelectedType] = useState(400);
  const { isPending: isLoadingSummaryGetData, data: RL3SummaryData } =
    useGetRL3SummaryData(id, selectedRL3SummaryType, taxYear);


  const onchangeTooltip = () => {
    //it have to optional from cosmic then remove it
  };
  const selectedSlip = formMethods.getValues("selectedSlip");

  return (
    <Toolbar>
      <>
        <div style={{ display: "contents" }}>
          <div style={{ margin: "1rem 0rem" }}>
            {RL3SummaryData &&
              RL3SummaryData.confirmationCode !== null &&
              selectedRL3SlipType === 400 ? (
              <div style={{ cursor: "not-allowed" }}>
                <DisabledButton
                  tooltiptitle={
                    "Confirmation No. has been enterned in [Complaince -> RL-3 -> Summary]"
                  }
                  isDisabled={true}
                  buttonLabel={"Submit"}
                  icon={<PlaylistAddCheckOutlinedIcon />}
                  testId="disableButton"
                  onClick={onchangeTooltip}
                />
              </div>
            ) : (
              <SubmitButton
                label="Submit"
                testId="submit-button"
                loading={isSubmitting}
                icon={<PlaylistAddCheckOutlinedIcon />}
              />
            )}
          </div>
          <ResetButton testId="reset-button" onClickHandler={onResetClicked} />
          <div style={{ margin: "1rem 0rem" }}>
            {RL3SummaryData &&
              RL3SummaryData.confirmationCode !== null &&
              selectedRL3SlipType === 400 ? (
              <div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
                <DisabledButton
                  tooltiptitle={
                    "Confirmation No. has been enterned in [Complaince -> t4 -> Summary]"
                  }
                  isDisabled={true}
                  buttonLabel={"Delete"}
                  icon={<DeleteOutlineIcon />}
                  testId="disableButton"
                  onClick={onchangeTooltip}
                />
              </div>
            ) : selectedSlip && selectedSlip === "create-new" ? (
              <div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
                <DisabledButton
                  tooltiptitle={""}
                  isDisabled={true}
                  buttonLabel={"Delete"}
                  icon={<DeleteOutlineIcon />}
                  testId="disableButton"
                  onClick={onchangeTooltip}
                />
              </div>
            ) : (
              <DeleteButton
                testId="delete-button"
                onClickHandler={onDeleteClicked}
              />
            )}
          </div>
        </div>
        <div style={{ flexGrow: 1 }} />
        <div>
          {selectedSlip && selectedSlip === "create-new" ? (
            <div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
              <DisabledButton
                tooltiptitle={""}
                isDisabled={true}
                buttonLabel={"Print"}
                icon={<PrintIcon />}
                testId="disableButton"
                onClick={onchangeTooltip}
              />
            </div>
          ) : (
            <PrintButton
              onClickHandler={onPrintClicked}
              testId="rl3-slip-print-button" label={"RL-3"}
            />
          )}
        </div>
      </>
    </Toolbar>
  );
};
